import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ipSharedClickStopPropagation]',
  standalone: true,
})
export class ClickStopPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
